<div class="p-blockui p-component-overlay" *ngIf="dialogBlock" style="z-index: 100;"></div>
<div class="operate-button">
    <p-speedDial [model]="operatePageButtons" direction="down-left" type="quarter-circle" showIcon="pi pi-folder"
        hideIcon="pi pi-folder-open"></p-speedDial>
</div>
<div class="layout-content" [ngStyle]="{'height': httpHelp.pageHeight}">
    <div class="search-panel" #truckSearchPanel>
        <form [formGroup]="searchForm">
            <div class="form-item" name="startTime" *ngIf="searchFormName['startTime']['show']">
                <label for="startTime" class="p-mr-2 p-d-inline">创建时间</label>
                <p-calendar formControlName="startTime" id="startTime" class="p-inputtext-sm" dateFormat="yy-mm-dd"
                    dataType="string"></p-calendar>
            </div>
            <div class="form-item" name="endTime" *ngIf="searchFormName['endTime']['show']">
                <label for="endTime" class="p-mr-2 p-d-inline p-ml-2">至</label>
                <p-calendar formControlName="endTime" id="endTime" class="p-inputtext-sm" dateFormat="yy-mm-dd"
                    dataType="string"></p-calendar>
            </div>
            <div class="form-item" name="cusId" *ngIf="searchFormName['cusId']['show']">
                <label for="cusId" class="p-mr-2 p-d-inline">托运方</label>
                <p-dp-detail [options]="searchShipperList" formControlName="cusId"
                    class="p-mr-2 p-d-inline p-inputtext-sm" id="cusId" appendTo="body" filter="true"
                    [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>
            <!-- <div class="form-item" name="plateNumber" *ngIf="searchFormName['plateNumber']['show']">
                <label for="goods_name" class="p-mr-2 p-d-inline">车牌号</label>
                <input type="text" id="plateNumber" pInputText class="p-mr-2 p-d-inline" class="p-inputtext-sm"
                    formControlName="plateNumber" />
            </div> -->
            <div class="form-item" name="plateNumber" *ngIf="searchFormName['plateNumber']['show']">
                <label for="plateNumber" class="p-mr-2 p-d-inline">车牌号</label>
                <p-dp-detail [options]="plateNumberList" formControlName="id" (onFilter)="getPlateNumber($event)"
                    filter="true" class="p-mr-2 p-d-inline p-inputtext-sm" id="plateNumber" appendTo="body"
                    [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>
            <div class="form-item" name="ownName" *ngIf="searchFormName['ownName']['show']">
                <label for="ownName" class="p-mr-2 p-d-inline">业户名称</label>
                <input type="text" id="ownName" pInputText class="p-mr-2 p-d-inline" class="p-inputtext-sm"
                    formControlName="ownName" />
            </div>
            <div class="form-item" name="useStatus" *ngIf="searchFormName['useStatus']['show']">
                <label for="useStatus" class="p-mr-2 p-d-inline">使用状态</label>
                <p-dp-detail [options]="useStatusList" formControlName="useStatus"
                    class="p-mr-2 p-d-inline p-inputtext-sm" id="useStatus" appendTo="body" [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>
            <div class="form-item" name="teamId" *ngIf="searchFormName['teamId']['show']">
                <label for="teamId" class="p-mr-2 p-d-inline">车主名称</label>
                <p-dp-detail [options]="teamList" formControlName="teamId" (onFilter)="getTeamId($event)" filter="true"
                    class="p-mr-2 p-d-inline p-inputtext-sm" id="plateNumber" appendTo="body"
                    [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>
            <div class="form-item" name="plateNumbers" *ngIf="searchFormName['plateNumbers']['show']">
                <label for="plateNumbers" class="p-mr-2 p-d-inline">批量车牌号</label>
                <input type="text" id="plateNumbers" pInputText class="p-mr-2 p-d-inline" class="p-inputtext-sm"
                    formControlName="plateNumbers" />
                <div style="margin-left: 5px;">
                    <i class="pi pi-plus-circle" style="font-size: 18px;cursor: pointer;color: rgb(139, 167, 151);"
                        (click)="batchPlateNumber()"></i>
                </div>
            </div>
            <div class="form-item" name="agentId" *ngIf="searchFormName['agentId']['show']">
                <label for="agentId" class="p-mr-2 p-d-inline">区域合伙人</label>
                <p-dp-detail [options]="searchAgentList" formControlName="agentId"
                    class="p-mr-2 p-d-inline p-inputtext-sm" id="agentId" appendTo="body" filter="true"
                    [style]="{'width':'165px'}">
                </p-dp-detail>
            </div>
            <!-- <button pButton pRipple type="button" icon="pi pi-sort-alt" class="p-button-rounded p-button-help"
                [style]="{transform:'rotate(90deg)'}" (click)="changeTableList()"></button>

                <button pButton pRipple type="button" icon="pi pi-cog" class="p-button-rounded p-button-help"
                (click)="editColumnDialog = true"></button> -->
        </form>
        <div
            style="width: 225px;color:var(--primary-color);font-size: small;cursor: pointer;display: flex;align-items: center;justify-content: flex-end;">
            <button pButton pRipple type="button" label="查询" icon="pi pi-search" class="p-button-sm "
                buttonClass="p-button-sm" (click)="queryList()"></button>
            <button pButton pRipple type="button" label="重置" icon="pi pi-replay" class="p-button-outlined p-button-sm p-ml-2 p-button p-component ng-star-inserted"
               (click)="resetQuery()"></button>
            <div class="p-ml-2" style="display: flex;align-items: center;">
                <i class="pi pi-angle-double-down" *ngIf="!showEsSearch" (click)="showEsQuery()"></i>
                <i class="pi pi-angle-double-up" *ngIf="showEsSearch" (click)="showEsQuery()"></i>
            </div>
        </div>
    </div>
    <div>
        <ng-container *ngFor="let item of hideSearchValue">
            <p-chip [label]="item['label'] + ':' + item['value']" [removable]="true" (onRemove)="deleteEsQuery(item)"
                class="p-ml-2" styleClass="custom-chip" icon="pi pi-search"></p-chip>
        </ng-container>
    </div>
    <div style="padding: 5px 0;">
        <div class="p-d-flex p-ai-center p-jc-between">
            <div class="p-d-flex search-panel-status">
                <ng-container *ngFor="let item of statusItems">
                    <div class="search-status" pRipple [ngClass]="{'search_status_active': item['checkFlag']}"
                        (click)="changeSearchStatus(item['value'])">
                        {{item['label']}} <p-badge size="smaller" [value]="item['value']"
                            [severity]="item['checkFlag'] ? 'danger': 'info'" styleClass="p-ml-1"></p-badge>
                    </div>
                </ng-container>
            </div>
            <div class="p-d-flex search-panel-status">
                <ng-container *ngFor="let item of certificateExpiredCountItems">
                    <div class="search-status" pRipple [ngClass]="{'search_status_active': item['checkFlag']}"
                        (click)="changeCertificateExpiredCountItems(item['value'])">
                        {{item['label']}} <p-badge size="smaller" [value]="item['value']"
                            [severity]="item['checkFlag'] ? 'danger': 'info'" styleClass="p-ml-1"></p-badge>
                    </div>
                </ng-container>
            </div>
            <div class="p-d-flex search-panel-status" style="margin-left: 10px;margin-right: 10px;">
                <ng-container *ngFor="let item of isMemberTruckItem">
                    <div class="search-status" pRipple [ngClass]="{'search_status_active': item['checkFlag']}"
                        (click)="changeIsMemberTruckItemStatus(item['value'])">
                        {{item['label']}} <p-badge size="smaller" [value]="item['value']"
                            [severity]="item['checkFlag'] ? 'danger': 'info'" styleClass="p-ml-1"></p-badge>
                    </div>
                </ng-container>
            </div>
            <div>
                <!-- <auth-button buttonId="trucks_add" type="button" label="新增" icon="pi pi-plus"
                    buttonClass="p-button-sm p-mr-2" (onClick)="editMyTruck()"></auth-button> -->
                <!-- <auth-button buttonId="trucks_check" type="button" label="批量审核"
                    [disabled]="!selectedItem || !selectedItem.length" icon="pi pi-check"
                    buttonClass="p-button-sm p-button-success p-mr-2" (onClick)="checkTruck()"></auth-button> -->
                <!-- <auth-button buttonId="trucks_del" type="button" label="删除"
                    [disabled]="!selectedItem || !selectedItem.length" icon="pi pi-trash"
                    buttonClass="p-button-sm p-button-danger p-mr-2" (onClick)="delete()"></auth-button> -->

                <button pButton pRipple type="button" label="证件导出" icon="pi pi-file-export"
                    class="p-button-sm p-button-success p-mr-2" (click)="exportTruckCertificates()"></button>
                <auth-button buttonId="export_trucks_data" type="button" label="导出" icon="pi pi-cloud-download"
                    buttonClass="p-button-sm p-button-success p-mr-2" (onClick)="exportCheckExcel()"></auth-button>
                <auth-button buttonId="choose_trucks_data" type="button" label="导入" icon="pi pi-cloud-download"
                    buttonClass="p-button-sm p-button-success p-mr-2" (onClick)="chooseExcel()"></auth-button>
                <!-- <auth-button buttonId="shipper_trucks" type="button" label="关联托运方"
                    [disabled]="!selectedItem || !selectedItem.length" icon="pi pi-plus"
                    buttonClass="p-button-sm p-button-success p-mr-2" (onClick)="relDriversDialog1()"></auth-button>
                <auth-button buttonId="agent_trucks" type="button" label="关联区域合伙人"
                    [disabled]="!selectedItem || !selectedItem.length" icon="pi pi-plus"
                    buttonClass="p-button-sm p-button-success p-mr-2" (onClick)="relAgentTruckDialog()"></auth-button>
                <auth-button buttonId="team-truck" type="button" label="关联车主"
                    [disabled]="!selectedItem || !selectedItem.length" icon="pi pi-plus"
                    buttonClass="p-button-sm p-button-success p-mr-2" (onClick)="relTeamTruckDialog()"></auth-button>
                <auth-button buttonId="team-truck" type="button" label="锁定"
                    [disabled]="!selectedItem || !selectedItem.length" icon="pi pi-lock"
                    buttonClass="p-button-sm p-button-success p-mr-2" (onClick)="toggleLockTeamDialog()">
                </auth-button> -->
            </div>
        </div>
    </div>
    <div class="main-table" [ngStyle]="{overflow:listOfData.length == 0 ? 'hidden' : 'auto'}" *ngIf="changeTable">
        <p-table [value]="listOfData" styleClass="p-datatable-sm  p-datatable-gridlines" [resizableColumns]="true"
            columnResizeMode="expand" [@filterAnimation]="loadingNum" [scrollable]="true"
            [scrollable]="listOfData.length == 0 ? false: true" scrollHeight="flex" scrollHeight="flex"
            [(selection)]="selectedItem" [rowHover]="listOfData.length == 0 ? false : true" selectionMode="single"
            dataKey="id">
            <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                    <col style="width:50px">
                    <col style="width:36px">
                    <ng-container *ngFor="let key of keys;">
                        <col *ngIf="key.show" [style]="{width:key.width}" />
                    </ng-container>
                    <col style="width:330px">
                </colgroup>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:50px;text-align: center;" class="first frozenColumn pLeftFrozenColumn th">
                        序号
                    </th>
                    <th class="pLeftFrozenColumn frozenColumn th">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <ng-container *ngFor="let key of keys;">
                        <th *ngIf="key.show" pResizableColumn class="th"
                            [class]="{'pLeftFrozenColumn': key.fix, 'frozenColumn': key.fix}"
                            style="text-align: center;">
                            {{key['label']}}
                        </th>
                    </ng-container>
                    <th style="position:sticky!important;; right:0px;z-index: 2;text-align: center;"
                        class="frozenColumn pRightFrozenColumn th">操作
                        <i class="pi pi-cog p-ml-2" style="cursor: pointer;" (click)="editColumnDialog = true"></i>

                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-res>
                <tr [pSelectableRow]="res" [pSelectableRowIndex]="rowIndex">
                    <td style="width:50px;text-align: center;" class="first frozenColumn pLeftFrozenColumn td">
                        {{first+rowIndex+1}}
                    </td>
                    <td class="pLeftFrozenColumn frozenColumn td">
                        <p-tableCheckbox [value]="res"></p-tableCheckbox>
                    </td>
                    <ng-container *ngFor="let key of keys;">
                        <td *ngIf="key.show" pResizableColumn class="td"
                            [class]="{'pLeftFrozenColumn': key.fix, 'frozenColumn': key.fix}"
                            style="text-align: center;"
                            [ngStyle]="key['colorFormat'] ? keysFunction[key['key']].colorFormat(res[key['key']], res) : {}">
                            <ng-container *ngIf="key.keyTyps == 'orderLink'">
                                <a href="javascript:;" pRipple class="edit-font" style="text-decoration: none;"
                                    (click)="showDetail(res)">{{res[key['key']]}}</a>
                            </ng-container>
                            <ng-container *ngIf="key.keyTyps == 'tag'">
                                <p-tag
                                    [value]="key['format']?keysFunction[key['key']].format(res[key['key']], key) : res[key['key']]"
                                    [rounded]="true"
                                    [style]="{'background-color': keysFunction[key['key']].colorFormat(res[key['key']], key)}">
                                </p-tag>
                            </ng-container>
                            <ng-container *ngIf="key.keyTyps == 'certificateExpiredTag'">
                                <span style="color: #008000;" *ngIf="res.certificateExpiredCount == 0">无过期</span>
                                <div style="color: red;" *ngIf="res.certificateExpiredCount != 0">
                                    <ng-container *ngIf="res.certificateExpiredIds.includes(',')">
                                        <span *ngFor="let item of res.certificateExpiredIds.split(',')"
                                            style="margin-left: 5px;margin-right: 5px;">
                                            {{item == 1 ? '年检' : item == 2 ? '道路运输证' : ''}}
                                        </span>
                                    </ng-container>
                                    <ng-container *ngIf="!res.certificateExpiredIds.includes(',')">
                                        {{res.certificateExpiredIds == 1 ? '年检' : res.certificateExpiredIds == 2 ?
                                        '道路运输证' : ''}}
                                    </ng-container>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="key.keyTyps ==  'vehicleExaminedExpirationDate'">
                                <span [style]="{color:getDateDiffInDays(res[key['key']]) < 0 ? 'red' : 'black'}">
                                    {{res[key['key']]}}
                                </span>
                                <span
                                    *ngIf="getDateDiffInDays(res[key['key']]) < 30 && getDateDiffInDays(res[key['key']]) > 0"
                                    style="color: red;">即将过期</span>
                                <span *ngIf="getDateDiffInDays(res[key['key']]) < 0" style="color: red;">已过期</span>
                            </ng-container>
                            <ng-container *ngIf="key.keyTyps ==  'optCertExpireTime'">
                                <span [style]="{color:getDateDiffInDays(res[key['key']],true) < 0 ? 'red' : 'black'}">
                                    {{setCreateTime(res[key['key']] * 1000, "yyyy-MM-dd") }}
                                </span>
                                <span
                                    *ngIf="getDateDiffInDays(res[key['key']],true) < 30 && getDateDiffInDays(res[key['key']],true) > 0"
                                    style="color: red;">即将过期</span>
                                <span *ngIf="getDateDiffInDays(res[key['key']],true) < 0" style="color: red;">已过期</span>
                            </ng-container>
                            <ng-container *ngIf="key.keyTyps == 'reportStatus' && res['isMemberTruck'] == 0">
                                <p-tag
                                    [value]="key['format']?keysFunction[key['key']].format(res[key['key']], key) : res[key['key']]"
                                    [rounded]="true"
                                    [style]="{'background-color': keysFunction[key['key']].colorFormat(res[key['key']], key)}">
                                </p-tag>
                            </ng-container>
                            <ng-container *ngIf="key.keyTyps == 'reportStatus' && res['isMemberTruck'] != 0">
                                <span>-</span>
                            </ng-container>
                            <ng-container *ngIf="!key.keyTyps">
                                {{ key['format'] ? keysFunction[key['key']].format(res[key['key']], key) :
                                res[key['key']] }}
                            </ng-container>
                        </td>
                    </ng-container>
                    <td class="right frozenColumn pRightFrozenColumn td">
                        <ng-container>
                            <!-- <auth-button type="button" [isButton]=false buttonId="truck_rel_team" label="车主" pRipple
                                class="edit-font" (click)="queryRelTeam(res)"></auth-button>
                            <auth-button type="button" [isButton]=false buttonId="truck_rel_driver" label="司机" pRipple
                                class="edit-font" (click)="editMyTruck(res, 1)"></auth-button> -->
                            <!-- <auth-button type="button" [isButton]=false buttonId="drivers_update" label="上报" pRipple
                            *ngIf="res.reportStatus==1" class="edit-font"
                            (click)="handleReport(res)"></auth-button> -->
                             <a  href="javascript:;" *ngIf="res['checkFlag'] != 2"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="editMyTruck(res, 1)">修改</a>
                            <a  href="javascript:;"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="checkDriverFlag(res)">审核</a>
                            <a  href="javascript:;" 
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="myDriverRes(res)">司机</a>
                            <a  href="javascript:;" 
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="relDriversDialog(res)">关联托运方</a>
                            <a  href="javascript:;"
                           class="edit-font" style="margin-left: 5px;margin-right: 5px;"
                            (click)="relAgentTruck(res)">关联区域合伙人</a>
                            <!-- <auth-button type="button" [isButton]=false buttonId="truck_update" label="修改" pRipple
                                *ngIf="res['checkFlag'] != 2" class="edit-font"
                                (click)="editMyTruck(res, 1)"></auth-button>
                            <auth-button type="button" [isButton]=false buttonId="truck_check" label="审核" pRipple
                                class="edit-font" (click)="checkDriverFlag(res)">
                            </auth-button>
                            <auth-button type="button" [isButton]=false buttonId="truck_rel_driver" label="司机" pRipple
                                buttonClass="p-button-sm p-ml-2 p-button-outlined"
                                (click)="myDriverRes(res)"></auth-button>

                            <auth-button type="button" [isButton]=false buttonId="shipper_trucks" label="关联托运方" pRipple
                                class="edit-font" (click)="relDriversDialog(res)"></auth-button>
                            <auth-button type="button" [isButton]=false buttonId="agent_trucks" label="关联区域合伙人" pRipple
                                class="edit-font" (click)="relAgentTruck(res)"></auth-button> -->
                        </ng-container>

                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <!-- 2指初始化锁定列，复选框、操作，如果只有一种则改为1 -->
                    <td [attr.colspan]="getCurrentKeyLength(keys) + 2" style="text-align: center;border-bottom: 0;">
                        <div style="margin-top: 50px;width:calc(100vw - 240px);" [@emptyData]="emptyData">
                            <img class="emptyImg" src="assets/file/image/emptyData.png"
                                style="width:240px;height:240px;" />
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="main-table" style="background-color: var(--surface-b-m);overflow-y: auto;" *ngIf="!changeTable"
        [@filterAnimation]="loadingNum">
        <div *ngIf="listOfData.length==0"
            style="width:100%;height:100%;align-items: center;text-align: center;padding-top: 100px;">
            <img class="emptyImg" src="assets/file/image/emptyData.png" style="width:240px;height:240px;" />
        </div>
        <div class="table-box" *ngFor="let item of listOfData">
            <div style="width:100%;height:100%;display:flex;align-items: center;">
                <div class="companyList-left">
                    <p-checkbox [value]="item" [(ngModel)]="selectedItem"></p-checkbox>
                </div>
                <div style="width:100%;">
                    <div class="box-top" style="margin-top:15px;">
                        <div class="box-top-left" class="p-display">
                            <div class="company-name edit-font p-mr-3" (click)="showDetail(item)">
                                {{item['plateNumber']}}
                            </div>

                            <img class="p-mr-3" *ngIf="item['source']==0" [pTooltip]="'来源：'+this.source[item['source']]"
                                tooltipPosition="top" src="assets/icon/pc.png" alt="">
                            <img class="p-mr-3" *ngIf="item['source']==1" [pTooltip]="'来源：'+this.source[item['source']]"
                                tooltipPosition="top" src="assets/icon/execl.png" alt="">
                            <img class="p-mr-3" *ngIf="item['source']==2" [pTooltip]="'来源：'+this.source[item['source']]"
                                tooltipPosition="top" src="assets/icon/wechat.png" alt="">
                            <img class="p-mr-3" *ngIf="item['source']==3" [pTooltip]="'来源：'+this.source[item['source']]"
                                tooltipPosition="top" src="assets/icon/mobile.png" alt="">

                            <div class="recentPosition p-mr-3" *ngIf="item['plateNumber'].length==8">
                                <img pTooltip="新能源" tooltipPosition="top" src="assets/icon/tram.png" alt="">
                            </div>

                            <div [class]="item['useStatus']==0 ? 'company-status p-mr-3' : 'company-permit p-mr-3'">
                                {{this.useStatus[item['useStatus']]}}</div>
                            <div class="company-contract p-mr-3"
                                *ngIf="getExpireDays(item['optCertExpireTime'],'',item['expiredWarnDay']) > 0">
                                道路运输证{{getExpireDays(item['optCertExpireTime'],'',item['expiredWarnDay'])}}天后过期</div>
                            <div class="company-permit p-mr-3"
                                *ngIf="getExpireDays(item['optCertExpireTime'],'',item['expiredWarnDay']) < 0">
                                道路运输证已过期{{getExpireDays(item['optCertExpireTime'],1,item['expiredWarnDay'])}}天</div>

                            <div class="company-contract p-mr-3"
                                *ngIf="getExpireDays(item['businessCertificateExpireTime'],'',item['expiredWarnDay']) > 0">
                                经营许可证{{getExpireDays(item['businessCertificateExpireTime'],'',item['expiredWarnDay'])}}天后过期
                            </div>
                            <div class="company-permit p-mr-3"
                                *ngIf="getExpireDays(item['businessCertificateExpireTime'],'',item['expiredWarnDay']) < 0">
                                经营许可证已过期{{getExpireDays(item['businessCertificateExpireTime'],1,item['expiredWarnDay'])}}天
                            </div>

                            <div class="company-permit" *ngIf="item['checkFlag'] == 3">不通过原因：{{item['checkLog']}}</div>
                        </div>
                        <div class="box-top-right p-display" style="padding-right: 50px;">
                            <div class="recentPosition p-mr-3">
                                <img src="assets/icon/map-location.png" alt="">&nbsp;
                                <span *ngIf="item.formattedAddress">{{item.formattedAddress}}
                                    <span class="auditor" [pTooltip]="'定位时间：'+this.setCreateTime(item['addTime']*1000)"
                                        tooltipPosition="top">（{{this.dateDiff(item['addTime']*1000)}}）</span>
                                </span>
                                <span class="auditor" *ngIf="!item.formattedAddress">暂无</span>
                            </div>
                            <ng-container *ngIf="item['checkFlag'] == 2 || item['checkFlag'] == 3">
                                <div class="auditor p-mr-3">审核人: {{item['checkName']}}</div>
                                <div class="audit-time">审核时间: {{this.setCreateTime(item['checkTime']*1000)}}</div>
                            </ng-container>
                            <!-- <ng-container>
                                <div class="company-status p-mr-5">
                                    {{checkFlag[item['checkFlag']]}}
                                </div>
                            </ng-container> -->
                        </div>
                        <div class="audit-status">
                            <img style="width: 60px; height: 60px;" *ngIf="item.checkFlag==1"
                                src="assets/icon/audit-status.png" alt="">
                            <img style="width: 60px; height: 60px;" *ngIf="item.checkFlag==2"
                                src="assets/icon/audit-status1.png" alt="">
                            <img style="width: 60px; height: 60px;" *ngIf="item.checkFlag==3"
                                src="assets/icon/audit-status2.png" alt="">
                        </div>
                    </div>
                    <div style="display:flex;align-items: center;">
                        <div class="td-box" style="margin:0;">
                            <ng-container *ngFor="let key of keys">
                                <div class="td-item" style="margin:0;"
                                    *ngIf="notPartKey.indexOf(',' + key.key + ',') == -1 && key.show">
                                    <label>{{key['label']}} : </label>
                                    <span
                                        [pTooltip]="key['format'] ? keysFunction[key['key']].format(item[key['key']], item):item[key['key']]"
                                        tooltipPosition="top">{{ key['format'] ?
                                        keysFunction[key['key']].format(item[key['key']], item) :
                                        item[key['key']] }}</span>
                                </div>
                            </ng-container>
                        </div>
                        <div
                            style="width: auto; display: flex; align-items: center;margin-bottom:10px;margin-right: 25px;">
                            <div style="margin: 2px 0;" *ngIf="item['checkFlag'] != 2">
                                <auth-button type="button" [isButton]=true buttonId="truck_update" label="修改" pRipple
                                    buttonClass="p-button-sm p-ml-2 p-button-outlined" (onClick)="editMyTruck(item, 1)">
                                </auth-button>
                            </div>
                            <div style="margin: 2px 0;">
                                <auth-button type="button" [isButton]=true buttonId="truck_check" label="审核" pRipple
                                    buttonClass="p-button-sm p-ml-2 p-button-outlined"
                                    (onClick)="checkDriverFlag(item)">
                                </auth-button>
                            </div>

                            <div style="margin: 2px 0;">
                                <auth-button type="button" [isButton]=true buttonId="truck_rel_driver" label="司机"
                                    pRipple buttonClass="p-button-sm p-ml-2 p-button-outlined"
                                    (click)="myDriverRes(item)"></auth-button>
                            </div>
                            <div style="margin: 2px 0;">
                                <auth-button type="button" [isButton]=true buttonId="shipper_trucks" label="关联托运方"
                                    pRipple buttonClass="p-button-sm p-ml-2 p-button-outlined"
                                    (click)="relDriversDialog(res)"></auth-button>
                            </div>
                            <div style="margin: 2px 0;">
                                <auth-button type="button" [isButton]=true buttonId="agent_trucks" label="关联区域合伙人"
                                    pRipple buttonClass="p-button-sm p-ml-2 p-button-outlined"
                                    (click)="relAgentTruck(res)"></auth-button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <p-paginator showCurrentPageReport=true [first]="first"
        currentPageReportTemplate="共 {totalRecords} 条记录 第 {currentPage} / {totalPages} 页 " [rows]="defaultRows"
        [rowsPerPageOptions]="[10,30,50,100]" pageLinkSize="3" [totalRecords]="totalNum" styleClass="p-paginator-sm"
        (onPageChange)="queryList($event)"></p-paginator>
</div>

<!-- 填写车辆信息开始 -->
<p-dialog [(visible)]="myTruck['truckEditDialogFlag']" [modal]="false" class="edit-data"
    [style]="{width: dialog_width_large }" [draggable]="true" [resizable]="false" [keepInViewport]="false"
    *ngIf="myTruck['truckEditDialogFlag']" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            车辆编辑
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || myTruck['truckEditDialogFlag'] = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateTruckForm" style="width:100%;padding:0 16px 0 16px;">
        <div class="p-fluid p-formgrid p-grid" style="overflow-x:hidden;">
            <div class="p-field p-grid">
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="vehicleLicensePhotoUrl" image-viewer
                                    (click)="priviewImgs(vehicleLicensePhotoUrl)" class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    行驶证主页<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传车辆行驶证扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #vehicleLicensePhotoFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectLicense($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '480px', height: '75px',right: '380px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="vehicleLicensePhotoUrl=='assets/file/image/xsz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #vehicleLicensePhotoInput type="hidden"
                                        (click)="vehicleLicensePhotoFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="vehicleLicenseBackPhotoUrl" image-viewer
                                    (click)="priviewImgs(vehicleLicenseBackPhotoUrl)" class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    行驶证副页
                                    <!-- <span class="label-sel">*</span> -->
                                </div>
                                <div>
                                    请上传车辆行驶证扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #vehicleLicenseBackPhotoFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectLicenseBack($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '480px', height: '75px',right: '380px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="vehicleLicenseBackPhotoUrl=='assets/file/image/xsz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #vehicleLicenseBackPhotoInput type="hidden"
                                        (click)="vehicleLicenseBackPhotoFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="optCertPhotoUrl" image-viewer (click)="priviewImgs(optCertPhotoUrl)"
                                    class="upload-file-back" />
                                <!-- <div class="upload-file-back"
                                    [style]="{'background-image': 'url('+ uploadFileUrl.optCertPhotoUrl +')'}">
                                </div> -->
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    道路运输证照片<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传道路运输证扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #optCertPhotoFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectOptCert($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '480px', height: '75px',right: '380px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="optCertPhotoUrl=='assets/file/image/dlysz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #optCertPhotoFileInput type="hidden"
                                        (click)="optCertPhotoFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="vehicleLicenseCheckPhotoUrl" image-viewer
                                    (click)="priviewImgs(vehicleLicenseCheckPhotoUrl)" class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    车辆年审页照片<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传车辆年审页照片，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #vehicleLicenseCheckFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectVehicleLicenseCheck($event)" [fileLimit]="1"
                                        accept="image/*" multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '480px', height: '75px',right: '380px',bottom: '23px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="vehicleLicenseCheckPhotoUrl=='assets/file/image/xszfy.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #vehicleLicenseCheckFileInput type="hidden"
                                        (click)="vehicleLicenseCheckFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-12"
                    style="font-weight: 700;font-size:18px;color: var(--text-color);padding-top: 15px;">车辆基本信息</div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="plateNumber">车牌号
                        <span class="label-sel">*</span>
                    </label>
                    <input id="plateNumber" type="text" pInputText formControlName="plateNumber" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'plateNumber')" class="p-error block error-msg">
                        请填写车牌号
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="vehicleType">车辆类型
                        <span class="label-sel">*</span>
                    </label>
                    <p-dp-detail [options]="vehicleTypeList" formControlName="vehicleType" filter="true"
                        id="vehicleType" appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'vehicleType')" class="p-error block error-msg">
                        请选择车辆类型
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="length">车辆长度(mm)</label>
                    <input id="length" type="number" pInputText formControlName="length" class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="width">车辆宽度(mm)</label>
                    <input id="width" type="number" pInputText formControlName="width" class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="height">车辆高度(mm)</label>
                    <input id="height" type="number" pInputText formControlName="height" class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="loadWeight">车辆核载(KG)
                        <span class="label-sel">*</span>
                    </label>
                    <input id="loadWeight" type="number" pInputText formControlName="loadWeight" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'loadWeight')" class="p-error block error-msg">
                        请填写车辆核载
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="fullLoadWeight">车辆满载(KG)
                        <span class="label-sel">*</span>
                    </label>
                    <input id="fullLoadWeight" type="number" pInputText formControlName="fullLoadWeight"
                        class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'fullLoadWeight')"
                        class="p-error block error-msg">
                        请填写车辆满载
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="trailerVolume">车辆体积(方)</label>
                    <input id="trailerVolume" type="number" pInputText formControlName="trailerVolume"
                        class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="model">车辆品牌</label>
                    <input id="model" type="text" pInputText formControlName="model" class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="plateColor">车牌颜色
                        <span class="label-sel">*</span>
                    </label>
                    <p-dp-detail [options]="plateColorLists" formControlName="plateColor" filter="true" id="plateColor"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'loadWeight')" class="p-error block error-msg">
                        请选择车牌颜色
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="energyType">车辆能源类型
                        <span class="label-sel">*</span>
                    </label>
                    <p-dp-detail [options]="energyTypeLists" formControlName="energyType" filter="true" id="energyType"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'energyType')" class="p-error block error-msg">
                        请选择车辆能源类型
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="trailerPlateNumber">挂车车牌
                        <span class="label-sel" *ngIf="isTractorVehicleType()">*</span>
                    </label>
                    <input id="trailerPlateNumber" type="text" pInputText formControlName="trailerPlateNumber"
                        class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'trailerPlateNumber') && isTractorVehicleType()"
                        class="p-error block error-msg">
                        请填写挂车车牌号码
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="trailerPlateColor">挂车车牌颜色
                        <span class="label-sel" *ngIf="isTractorVehicleType()">*</span>
                    </label>
                    <p-dp-detail [options]="plateColorLists" formControlName="trailerPlateColor" filter="true"
                        id="trailerPlateColor" appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'trailerPlateColor') && isTractorVehicleType()"
                        class="p-error block error-msg">
                        请选择挂车车牌颜色
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="truckSize">车长</label>
                    <p-dp-detail [options]="truckSizeLists" formControlName="truckSize" filter="true" id="truckSize"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="useCharacter">使用性质</label>
                    <p-dp-detail [options]="useCharacterLists" formControlName="useCharacter" filter="true"
                        id="useCharacter" appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="truckVin">车辆识别代码</label>
                    <input id="truckVin" type="text" pInputText formControlName="truckVin" class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="truckType">车型</label>
                    <p-dp-detail [options]="truckModelLists" formControlName="truckType" filter="true" id="truckType"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                </div>


                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="isPersonal">车辆属性
                        <span class="label-sel">*</span>
                    </label>
                    <p-dp-detail [options]="isPersonalLists" formControlName="isPersonal" filter="true" id="isPersonal"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'isPersonal')" class="p-error block error-msg">
                        请选择车辆属性
                    </small>
                </div>


                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="isPersonal">车主
                        <!-- <span class="label-sel">*</span> -->
                    </label>
                    <p-dp-detail [options]="teamIdList" formControlName="teamId" filter="true" id="teamId"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'teamId')" class="p-error block error-msg">
                        请选择车主
                    </small>
                </div>



                <div class="p-field p-col-3 p-md-12" style="font-weight: 700;font-size:18px;color: var(--text-color);">
                    证件信息
                </div>

                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="ownName">业户名称
                        <span class="label-sel">*</span>
                    </label>
                    <input id="ownName" type="text" pInputText formControlName="ownName" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'ownName')" class="p-error block error-msg">
                        请填写业户名称
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="ownCarrierId">业户社会信用代码</label>
                    <input id="ownCarrierId" type="text" pInputText formControlName="ownCarrierId"
                        class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="businessCertificate">经营许可证号
                        <!-- <span class="label-sel">*</span> -->
                    </label>
                    <input id="businessCertificate" type="text" pInputText formControlName="businessCertificate"
                        class="p-inputtext-sm">
                    <!-- <small *ngIf="checkFormItem(this.validateTruckForm, 'businessCertificate')"
                        class="p-error block error-msg">
                        请填写经营许可证号
                    </small> -->
                </div>
                <div class="p-field p-col-6 p-md-3  edit-sel">
                    <label for="businessCertificateExpireTime">经营许可证失效日期
                        <!-- <span class="label-sel">*</span> -->
                    </label>
                    <p-calendar inputId="businessCertificateExpireTime" formControlName="businessCertificateExpireTime"
                        appendTo="body" dateFormat="yy-mm-dd" dataType="string" class="p-inputtext-sm"></p-calendar>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'businessCertificateExpireTime')"
                        class="p-error block error-msg">
                        请选择经营许可证失效日期
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="optCertNo">道路运输证号
                        <span class="label-sel">*</span>
                    </label>
                    <input id="optCertNo" type="text" pInputText formControlName="optCertNo" class="p-inputtext-sm">
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'optCertNo')" class="p-error block error-msg">
                        请填写道路运输证号
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3  edit-sel">
                    <label for="optCertExpireTime">道路运输证失效日期
                        <!-- <span class="label-sel">*</span> -->
                    </label>
                    <p-calendar inputId="optCertExpireTime" formControlName="optCertExpireTime" appendTo="body"
                        dateFormat="yy-mm-dd" dataType="string" class="p-inputtext-sm"></p-calendar>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'optCertExpireTime')"
                        class="p-error block error-msg">
                        请选择道路运输证失效日期
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="issuingOrganizations">行驶证发证机关</label>
                    <input id="issuingOrganizations" type="text" pInputText formControlName="issuingOrganizations"
                        class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3  edit-sel">
                    <label for="registerDate">行驶证注册日期</label>
                    <p-calendar inputId="registerDate" formControlName="registerDate" dateFormat="yy-mm-dd"
                        appendTo="body" dataType="string" class="p-inputtext-sm">
                    </p-calendar>
                </div>
                <div class="p-field p-col-6 p-md-3  edit-sel">
                    <label for="issueDate">行驶证发证日期</label>
                    <p-calendar inputId="issueDate" formControlName="issueDate" dateFormat="yy-mm-dd" dataType="string"
                        appendTo="body" class="p-inputtext-sm">
                    </p-calendar>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="isOnline">入网状况</label>
                    <p-dp-detail [options]="onlineList" formControlName="isOnline" optionLabel="label"
                        optionValue="value" [style]="{width: '100%'}" appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="remark">备注</label>
                    <input id="remark" type="text" pInputText formControlName="remark" class="p-inputtext-sm">
                </div>
                <div class="p-field p-col-6 p-md-3  edit-sel">
                    <label for="vehicleExaminedExpirationDate">车辆年审有效期
                        <span class="label-sel">*</span>
                    </label>
                    <p-calendar inputId="vehicleExaminedExpirationDate" formControlName="vehicleExaminedExpirationDate"
                        appendTo="body" dateFormat="yy-mm-dd" dataType="string" class="p-inputtext-sm"></p-calendar>
                    <small *ngIf="checkFormItem(this.validateTruckForm, 'vehicleExaminedExpirationDate')"
                        class="p-error block error-msg">
                        请选择车辆年审有效期
                    </small>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" *ngIf="editDialogType == 1" (click)="saveTruck()" label="保存" class="p-button-text">
        </p-button>
        <p-button icon="pi pi-check" *ngIf="editDialogType == 2" (click)="check()" label="审核通过" class="p-button-text">
        </p-button>
        <p-button icon="pi pi-check" *ngIf="editDialogType == 2" (click)="check_waybill_noPass(res)" label="审核不通过"
            class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="myTruck['truckEditDialogFlag'] = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>
<!-- 填写车辆信息结束 -->

<!-- 锁定or解锁 -->
<p-dialog [(visible)]="lockTeamDialog" [style]="{width: dialog_width_small}" [draggable]="true" [resizable]="false"
    *ngIf="lockTeamDialog" [modal]="false" [keepInViewport]="false" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            锁定车主
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || lockTeamDialog = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="lockTeamForm" style="width:100%;padding:24px 16px 0 16px;">
        <div class="p-field p-grid">
            <label class="p-col-fixed" style="width:100px">锁定或解锁：</label>
            <div class="p-col edit-sel">
                <p-radioButton name="lockTeam" value="2" class="p-mr-2" inputId="lock"
                    formControlName="lockTeam"></p-radioButton>
                <label class="p-mr-3" for="lock">锁定</label>

                <p-radioButton name="lockTeam" value="1" class="p-mr-2" inputId="unlock"
                    formControlName="lockTeam"></p-radioButton>
                <label class="p-mr-3" for="unlock">解锁</label>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="saveTeamLock()" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="lockTeamDialog = false || this.dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="myTruck['truckCheckDialogFlag']" [modal]="false" [style]="{width: dialog_width_small}"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="myTruck['truckCheckDialogFlag']"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            请输入车牌号
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || myTruck['truckCheckDialogFlag'] = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <div style="width:100%;padding:24px 16px 0 16px;">
        <div class="p-field p-grid">
            <label for="account_no" class="p-col-fixed" style="width:90px;">
                车牌号
            </label>
            <div class="p-col">
                <span class="p-input-icon-right">
                    <i style="color: red;font-size: 14px;" *ngIf="myTruck['plateNumber'].length == 8"> 新能源 </i>
                    <input id="account_no" type="text" pInputText [(ngModel)]="myTruck['plateNumber']"
                        class="p-inputtext-sm" style="width:100%;" autocomplete="off">
                </span>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="queryTruck()" label="下一步" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="myTruck['truckCheckDialogFlag'] = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>
<!-- 审核不通过开始 -->
<p-dialog class="edit-order" [(visible)]="noCheckWaybillDialogFlag" position="center" [dismissableMask]="false"
    [modal]="false" [style]="{width:'500px'}" [draggable]="true" [resizable]="false" [keepInViewport]="false"
    [baseZIndex]="100000" *ngIf="noCheckWaybillDialogFlag" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            审核不通过
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || noCheckWaybillDialogFlag = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="checkWaybillForm" style="background-color: #ffffff;border-radius: 12px;padding:24px 16px;">
        <div class="p-field p-col-6 p-md-12 edit-sel">
            <div class="filed-input">
                <p-radioButton required name="checkLogTips" (click)="checkLogTipsClick(1)" value="1"
                    formControlName="checkLogTips">
                </p-radioButton>
                &nbsp;
                <label class="deposit">行驶证照片模糊</label>
                &nbsp;
                <p-radioButton required name="checkLogTips" (click)="checkLogTipsClick(2)" value="2"
                    formControlName="checkLogTips">
                </p-radioButton>
                &nbsp;
                <label class="fdeposit">道路运输证照片模糊</label>
            </div>
        </div>
        <div class="p-field p-col-6 p-md-12 edit-sel">
            <div class="filed-input">
                <p-radioButton required name="checkLogTips" (click)="checkLogTipsClick(3)" value="3"
                    formControlName="checkLogTips">
                </p-radioButton>
                &nbsp;
                <label class="fdeposit">行驶证不符</label>
                &nbsp;
                <p-radioButton required name="checkLogTips" (click)="checkLogTipsClick(5)" value="5"
                    formControlName="checkLogTips">
                </p-radioButton>
                &nbsp;
                <label class="fdeposit">道路运输证不符</label>
            </div>
        </div>
        <div class="p-field p-col-6 p-md-12 edit-sel">
            <div class="filed-input">
                <p-radioButton required name="checkLogTips" (click)="checkLogTipsClick(4)" value="4"
                    formControlName="checkLogTips">
                </p-radioButton>
                &nbsp;
                <label class="fdeposit">其它</label>
            </div>
        </div>
        <div class="p-field p-col-6 p-md-12 edit-sel" *ngIf="checkLogSwitch==1">
            <label for="check_log">其它原因
                <span class="label-sel">*</span>
            </label>
            <div class="filed-input">
                <textarea pInputTextarea formControlName="checkLog" rows="5" cols="30" autoResize="autoResize"
                    style="width:98%"></textarea>
                <small *ngIf="checkFormItem(this.checkWaybillForm, 'checkLog')" class="p-error block error-msg">
                    请填写审核不通过原因
                </small>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="noCheck()" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="noCheckWaybillDialogFlag = flase|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>
<!-- 审核不通过结束 -->

<!-- 司机审核弹窗 -->
<p-dialog [(visible)]="checksTruckDialog" [modal]="false" [style]="{width: dialog_width_small}" [baseZIndex]="10000"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="checksTruckDialog"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            批量审核
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || checksTruckDialog = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="checksTruckForm">
        <div class="p-field p-grid">
            <label for="checkFlag" class="p-col-fixed" style="width:90px;">审核状态</label>
            <div class="p-col">
                <p-radioButton name="checkFlag" value="2" class="p-mr-2" inputId="checkPass" formControlName="checkFlag"
                    (onClick)="changeCheckStatus(2)">
                </p-radioButton>
                <label class="p-mr-3" for="checkPass">审核通过</label>
                <p-radioButton name="checkFlag" value="3" class="p-mr-2" inputId="checkReject"
                    formControlName="checkFlag" (onClick)="changeCheckStatus(3)">
                </p-radioButton>
                <label class="p-mr-3" for="checkReject">审核不通过</label>
            </div>
        </div>
        <div class="p-field p-grid" *ngIf="currentDriverCheckFlag == 3">
            <label for="checkLog" class="p-col-fixed" style="width:90px;">审核备注</label>
            <div class="p-col">
                <input id="checkLog" type="text" pInputText formControlName="checkLog" style="width:100%;">
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="saveCheckTruck()" label="保存" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="checkDriverDialog = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<p-detail-sidebar *ngIf="myTruck.showTruckDetailFlag" [(visible)]="myTruck.showTruckDetailFlag" [showCloseIcon]="false"
    position="right" [style]="{width:'80%'}" transitionOptions="600ms ease-in-out">
    <app-truck-detail [truckDetail]="myTruck.truckDetail" (onClose)="myTruck.showTruckDetailFlag = false">
    </app-truck-detail>
</p-detail-sidebar>

<p-dialog class="edit-column" [(visible)]="editColumnDialog" [modal]="false" [style]="{width: dialog_width_small}"
    [baseZIndex]="-100" [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="editColumnDialog"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            编辑列
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="saveForRecord(this)" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <app-edit-column [keys]="keys"></app-edit-column>
</p-dialog>

<app-common-confirm></app-common-confirm>

<!-- 关联车主查询 -->
<p-dialog [(visible)]="relTeam['relTeamDialogFlag']" [modal]="false" [style]="{width: dialog_width_large}"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="relTeam['relTeamDialogFlag']"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            关联车主
            <span style="font-weight: 700;font-size: small;">( {{ dialogSubTitle }} )</span>
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || relTeam['relTeamDialogFlag'] = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <div class="button-panel">
        <button pButton pRipple type="button" label="新增" icon="pi pi-plus" class="p-button-sm p-mr-2"
            (click)="addTeamTruck()"></button>
        <button pButton pRipple type="button" label="审核"
            [disabled]="!relTeam['selectedRelTeamList'] || !relTeam['selectedRelTeamList'].length" icon="pi pi-plus"
            class="p-button-sm p-mr-2" (click)="checkTeamTruck()"></button>
        <button pButton pRipple type="button" label="删除"
            [disabled]="!relTeam['selectedRelTeamList'] || !relTeam['selectedRelTeamList'].length" icon="pi pi-trash"
            class="p-button-sm p-button-danger" (click)="delTeamTruck()"></button>
        <button pButton pRipple type="button" label="刷新" icon="pi pi-search" class="p-button-sm p-ml-2"
            (click)="queryRelTeam()"></button>
    </div>
    <p-table [value]="myTruck['relTeamList']" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex"
        [(selection)]="myTruck['selectedRelTeamList']">
        <ng-template pTemplate="header">
            <tr>
                <th style="width:36px">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th pResizableColumn style="text-align: center;width:120px;">区域合伙人</th>
                <th pResizableColumn style="text-align: center;width:120px;">托运方</th>
                <th pResizableColumn style="text-align: center;width:120px;">车主姓名</th>
                <th pResizableColumn style="text-align: center;width:120px;">手机号</th>
                <th pResizableColumn style="text-align: center;width:120px;">身份证号</th>
                <th pResizableColumn style="text-align: center;width:120px;">车主协议</th>
                <th pResizableColumn style="text-align: center;width:120px;">审核人</th>
                <th pResizableColumn style="text-align: center;width:120px;">审核日志</th>
                <th pResizableColumn style="text-align: center;width:120px;">审核时间</th>
                <th pResizableColumn style="text-align: center;width:120px;">操作</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-res>
            <tr>
                <td style="width:36px">
                    <p-tableCheckbox [value]="res"></p-tableCheckbox>
                </td>
                <td style="text-align: center;width:120px;">
                    {{this.agentMap[res.agent_id]}}
                </td>
                <td style="text-align: center;width:120px;">
                    {{this.shipperMap[res.shipper_id]}}
                </td>
                <td style="text-align: center;width:120px;">{{res.realname}}</td>
                <td style="text-align: center;width:120px;">{{res.mobilePhone}} </td>
                <td style="text-align: center;width:120px;">{{res.idCardNo}}</td>
                <td style="text-align: center;width:120px;">
                    <ng-container *ngIf="!res.agreementPhoto">
                        <a href="javascript:;" pRipple class="edit-font" (click)="uploadTeamTruckPhoto(res)">上传</a>
                    </ng-container>
                    <ng-container *ngIf="res.agreementPhoto">
                        <a href="javascript:;" pRipple class="edit-font" (click)="uploadTeamTruckPhoto(res)">上传</a>
                        <span style="margin: 0 4px;">|</span>
                        <a href="javascript:;" pRipple class="edit-font" (click)="checkTeamTruckPhoto(res)">查看</a>
                    </ng-container>
                </td>
                <td style="text-align: center;width:120px;">{{res.checkName}}</td>
                <td style="text-align: center;width:120px;">{{res.checkLog}} </td>
                <td style="text-align: center;width:120px;">{{res.checkTime}}</td>
                <td style="text-align: center;width:120px;">

                </td>
            </tr>
        </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <div style="height:20px;"></div>
    </ng-template>
</p-dialog>

<!-- 新增车主关联开始 -->
<p-dialog [(visible)]="relTeam['addRelTeamDialogFlag']" [modal]="false" class="edit-data"
    [style]="{width: dialog_width_small }" [draggable]="true" [resizable]="false" [keepInViewport]="false"
    *ngIf="relTeam['addRelTeamDialogFlag']" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            关联编辑
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || relTeam['addRelTeamDialogFlag'] = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateTramTruckForm" style="width:100%;padding:0 16px 0 16px;">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-grid">
                <div class="p-field p-col-6 p-md-12 edit-sel">
                    <label for="agentId">区域合伙人</label>
                    <p-dp-detail [options]="agentIdList" formControlName="agentId" filter="true" id="agentId"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                </div>
                <div class="p-field p-col-6 p-md-12 edit-sel">
                    <label for="shipperId">托运方</label>
                    <p-dp-detail [options]="shipperIdList" formControlName="shipperId" filter="true" id="shipperId"
                        appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                </div>
                <div class="p-field p-col-6 p-md-12 edit-sel">
                    <label for="teamId">车主</label>
                    <p-dp-detail [options]="relTeam['teamIdList']" formControlName="teamId" filter="true" id="teamId"
                        filter="true" appendTo="body" class="p-inputtext-sm">
                    </p-dp-detail>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="saveTruck()" label="保存" class="p-button-text">
        </p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="relTeam['addRelTeamDialogFlag'] = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>
<!-- 新增车主关联结束 -->

<!-- 车辆审核开始 -->
<p-detail-sidebar *ngIf="showTruckCheckFlag" [(visible)]="showTruckCheckFlag" [showCloseIcon]="false" position="right"
    [style]="{width:'80%'}" transitionOptions="600ms ease-in-out">
    <app-truck-examine [truckDetail]="localTruckDetail" (onClose)="closeExamDialog()" (onChecked)="queryList()"></app-truck-examine>
</p-detail-sidebar>

<!-- 导出司机数据 -->
<p-dialog [(visible)]="exportDialog" [modal]="false" [style]="{width: dialog_width_small}" [draggable]="true"
    [resizable]="false" [keepInViewport]="false" *ngIf="exportDialog" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            导出
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || exportDialog = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="exportForm" style="width:100%;padding:24px 16px 0 16px;">
        <div class="p-field p-grid">
            <label for="companyId" class="p-col-fixed" style="width:90px">数据类型：</label>
            <div class="p-col edit-sel">
                <p-radioButton name="exportTemplateType" value="1" class="p-mr-2" inputId="chooseData"
                    formControlName="exportTemplateType">
                </p-radioButton>
                <label class="p-mr-3" for="chooseData">查询数据</label>
                <p-radioButton name="exportTemplateType" value="2" class="p-mr-2" inputId="queryData"
                    formControlName="exportTemplateType" [disabled]="!selectedItem || !selectedItem.length">
                </p-radioButton>
                <label class="p-mr-3" for="queryData">勾选数据</label>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="exportExcel()" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="exportDialog = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>



<!-- 关联司机查询 -->
<p-dialog [(visible)]="relDriver['relDriverDialogFlag']" [modal]="false" [style]="{width: dialog_width_large}"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="relDriver['relDriverDialogFlag']"
    (onShow)="dialogBlock = true">
    <!-- <ng-template pTemplate="header">
        <span style="font-weight: 600;font-size: large;margin-right:20px;">
            司机列表
            <span style="font-weight: 700;font-size: small;">( {{ dialogSubTitle }} )</span>
        </span>
    </ng-template> -->
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            司机列表
            <span style="font-weight: 700;font-size: small;">( {{ dialogSubTitle }} )</span>
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || relDriver['relDriverDialogFlag'] = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <div class="button-panel">
        <button pButton pRipple type="button" label="新增" icon="pi pi-plus" class="p-button-sm p-mr-2"
            (click)="addDriverTruck()"></button>

        <button pButton pRipple type="button" label="删除"
            [disabled]="!relDriver['selectedrelDriverList'] || !relDriver['selectedrelDriverList'].length"
            icon="pi pi-trash" class="p-button-sm p-button-danger" (click)="delDriverTruck()"></button>
        <button pButton pRipple type="button" label="刷新" icon="pi pi-search" class="p-button-sm p-ml-2"
            (click)="queryRelTeam()"></button>
    </div>
    <p-table [value]="relDriver['relDriverList']" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex"
        [(selection)]="relDriver['selectedrelDriverList']" styleClass="p-datatable-sm  p-datatable-gridlines"
        [resizableColumns]="true" columnResizeMode="expand" selectionMode="single" dataKey="id">
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <col style="width:50px">
                <col style="width:36px">
                <col style="text-align: center;width:120px;" />
                <col style="text-align: center;width:120px;" />
                <col style="text-align: center;width:150px;" />
                <col style="text-align: center;width:130px;" />
                <col style="text-align: center;width:120px;" />
                <col style="text-align: center;width:130px;" />
                <col style="text-align: center;width:120px;" />
                <col style="text-align: center;width:120px;" />
                <col style="text-align: center;width:120px;" />
                <col style="text-align: center;width:120px;" />
                <col style="text-align: center;width:120px;" />
                <!-- <col style="width:260px"> -->
            </colgroup>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width:50px;text-align: center;" class="first frozenColumn pLeftFrozenColumn th">
                    序号
                </th>
                <th style="width:36px" class="th">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>

                <th pResizableColumn style="text-align: center;width:120px;" class="th">司机姓名</th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">手机号</th>
                <th pResizableColumn style="text-align: center;width:150px;" class="th">身份证号</th>
                <th pResizableColumn style="text-align: center;width:130px;" class="th">车辆审核状态</th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">车辆审核人</th>
                <th pResizableColumn style="text-align: center;width:130px;" class="th">车辆审核日志</th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">人车合照</th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">人车照审核状态</th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">人车照审核人</th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">人车照审核日志</th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">人车照审核时间</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowIndex="rowIndex" let-res>
            <tr [pSelectableRow]="res" [pSelectableRowIndex]="rowIndex">
                <td style="width:50px;text-align: center;" class="first frozenColumn pLeftFrozenColumn td">
                    {{first+rowIndex+1}}
                </td>
                <td style="width:36px" class="td">
                    <p-tableCheckbox [value]="res"></p-tableCheckbox>
                </td>
                <td style="text-align: center;width:120px;" class="td">{{res.driverName}}</td>
                <td style="text-align: center;width:120px;" class="td">{{res.driverPhone}} </td>
                <td style="text-align: center;width:150px;" class="td">{{res.idCardNo}}</td>
                <td style="text-align: center;width:130px;" class="td">{{checkFlag[res.relCheckFlag]}}</td>
                <td style="text-align: center;width:120px;" class="td">{{res.relCheckName}}</td>
                <td style="text-align: center;width:130px;" class="td">{{res.relCheckLog}}</td>
                <td style="text-align: center;width:120px;" class="td">
                    <ng-container *ngIf="!res.driverTruckPhoto">
                        <a href="javascript:;" pRipple class="edit-font" (click)="uploadDri(res)">上传</a>
                    </ng-container>
                    <ng-container *ngIf="res.driverTruckPhoto">
                        <a href="javascript:;" pRipple class="edit-font" (click)="uploadDri(res)">上传</a>
                        <span style="margin: 0 4px;">|</span>
                        <a href="javascript:;" pRipple class="edit-font" (click)="checkDriverTruckPhoto(res)">查看</a>
                    </ng-container>
                </td>
                <td style="text-align: center;width:120px;" class="td">{{checkFlag[res.checkFlag]}}</td>
                <td style="text-align: center;width:120px;" class="td">{{res.checkName}}</td>
                <td style="text-align: center;width:120px;" class="td">{{res.checkLog}} </td>
                <td style="text-align: center;width:120px;" class="td">
                    {{this.setCreateTime(res['checkTime']*1000)}}</td>

            </tr>
        </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <div style="height:20px;"></div>
    </ng-template>
</p-dialog>



<!-- 上传人车照 -->
<p-dialog [(visible)]="myTruck['driverTruckPhotoFlag']" position="center" [draggable]="true" [resizable]="false"
    [modal]="false" [style]="{width: dialog_width_small}" [keepInViewport]="false"
    *ngIf="myTruck['driverTruckPhotoFlag']" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            {{ myTruck.truckDetailHeader }}

        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || myTruck['driverTruckPhotoFlag'] = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <div>
        <div class="upload-photo-box" [style]="{backgroundImage: 'url(' + myTruck['driver_truck_photo_url'] + ')'}">
            <span class="upload-photo upload-photo-span">
                <p-fileUpload #uploadDriverTruckPhoto mode="basic" chooseLabel=""
                    (onSelect)="onSelectTruckFile($event, 'driver_truck_photo')" [fileLimit]="1" accept="image/*"
                    [style]="{'zIndex':'10',opacity:'0',width: '100%', height: '200px'}" name="uploadTruckPhotoFile"
                    maxFileSize="32*1048*1048"></p-fileUpload>
            </span>
            <input #uploadTruckInput type="hidden" (click)="uploadDriverTruckPhoto.clear()" />
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="saveUploadDriverTruckPhoto()" label="上传" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="myTruck['driverTruckPhotoFlag'] = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>


<!--验证司机开始-->
<p-dialog [(visible)]="editDriverIdCardDialogFlag" [modal]="false" class='edit-data'
    [style]="{width: dialog_width_small}" [draggable]="true" [resizable]="false" [keepInViewport]="false"
    (onShow)="editUploadIdCard.clear() || (identifyIdCardFrontUrl = 'assets/file/image/sfzFront.png')"
    *ngIf="editDriverIdCardDialogFlag" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            司机验证
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || editDriverIdCardDialogFlag = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateFormPhone" style="width:100%;padding:24px 16px 0 16px;">
        <div class="p-field upload-photo-box" [style]="{backgroundImage: 'url(' + identifyIdCardFrontUrl + ')'}">
            <span class="upload-photo upload-photo-span">
                <p-fileUpload #editUploadIdCard mode="basic" (onSelect)="identifyCard($event)" chooseLabel=""
                    [fileLimit]="1" accept="image/*"
                    [style]="{'zIndex':'10',opacity:'0',width: '100%', height: '200px'}" maxFileSize="32*1048*1048">
                </p-fileUpload>
            </span>
            <!-- 删除按钮 -->
            <a *ngIf="identifyIdCardFrontUrl != 'assets/file/image/sfzFront.png'" class="upload-photo-a"
                href="javascript:;" pRipple
                (click)="editUploadIdCard.clear() || (identifyIdCardFrontUrl = 'assets/file/image/sfzFront.png')">
                <i class="pi pi-trash"></i>
            </a>
        </div>
        <div class="p-field p-grid">
            <label for="idCardNo" class="p-col-fixed" style="width:90px;">身份证号</label>
            <div class="p-col">
                <p-inputMask id="idCardNo" formControlName="idCardNo" [style]="{width: '100%'}"
                    mask="999 999 9999 9999 999*" placeholder="请填写身份证号码" characterPattern="[*X]"></p-inputMask>
                <small *ngIf="checkFormItem(this.validateFormPhone, 'idCardNo')" class="p-error block error-msg">
                    请上传身份证头像面照片
                </small>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton pRipple icon="pi pi-check" type="button"
            [disabled]="photoUrl == '' && this.validateFormPhone.controls.idCardNo.value =='' " (click)="queryDriver()"
            label="下一步" class="p-button-raised"></button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="editDriverIdCardDialogFlag = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>
<!--验证司机结束-->



<!-- 编辑司机开始 -->
<p-dialog [(visible)]="editDialogFlag" [modal]="false" [style]="{width: '1000px'}" class="edit-data" [draggable]="true"
    [resizable]="false" [keepInViewport]="false" *ngIf="editDialogFlag" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            司机编辑
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || editDialogFlag = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateDriverTruckForm" style="width:100%;padding:0px 16px 0 16px;">
        <div class="p-fluid filed-body">
            <div class="p-field p-grid">
                <div class="p-md-6 field-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display ">
                            <div class="p-mr-3">
                                <img [src]="idCardFrontUrl" image-viewer (click)="priviewImgs(idCardFrontUrl)"
                                    class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    身份证头像面<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传身份证头像面扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #idCardFrontFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectIdcard($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '100px', height: '30px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="idCardFrontUrl=='assets/file/image/id-card-front.png' ? '点击上传' : '重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #idCardFrontInput type="hidden" (click)="idCardFrontFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 field-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="idCardBackUrl" image-viewer (click)="priviewImgs(idCardBackUrl)"
                                    class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    身份证国徽面<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传身份证国徽面扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #idCardBackFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectIdCardBack($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '100px', height: '30px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="idCardBackUrl=='assets/file/image/id-card-back.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #idCardBackInput type="hidden" (click)="idCardBackFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="drivingLicensePhotoUrl" image-viewer
                                    (click)="priviewImgs(drivingLicensePhotoUrl)" class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    驾驶证<span class="label-sel">*</span>
                                </div>
                                <div>
                                    请上传司机驾驶证扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #drivingLicensePhotoFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectBusiness($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '100px', height: '30px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="drivingLicensePhotoUrl=='assets/file/image/xsz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #drivingLicensePhotoInput type="hidden"
                                        (click)="drivingLicensePhotoFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-md-6 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="qualificationCertPhotoUrl" image-viewer
                                    (click)="priviewImgs(qualificationCertPhotoUrl)" class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    从业资格证
                                </div>
                                <div>
                                    请上传司机从业资格证扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #qualificationCertPhotoFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectQualificationCert($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '100px', height: '30px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="qualificationCertPhotoUrl=='assets/file/image/xsz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #qualificationCertPhotoInput type="hidden"
                                        (click)="qualificationCertPhotoFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="p-md-12 filed-item">
                    <div class="p-display upload-file-box">
                        <div class="p-display">
                            <div class="p-mr-3">
                                <img [src]="driverTruckPhotoUrl" image-viewer (click)="priviewImgs(driverTruckPhotoUrl)"
                                    class="upload-file-back" />
                            </div>
                            <div>
                                <div style="font-size:large;font-weight:700;">
                                    人车照
                                </div>
                                <div>
                                    请上传人车照片扫描件或数码照，支持jpg,jpeg,png格式照片
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 5;">
                                    <p-fileUpload #driverTruckFileUpload mode="basic" chooseLabel=""
                                        (onSelect)="onSelectDriverTruck($event)" [fileLimit]="1" accept="image/*"
                                        multiple="multiple"
                                        [style]="{'zIndex': '10',opacity:'0',width: '100px', height: '30px'}"
                                        maxFileSize="32*1048*1048"></p-fileUpload>
                                </span>
                                <span class="upload-photo upload-photo-span"
                                    style="width: '100px'; height: '30px';z-index: 2;">
                                    <button pButton pRipple type="button"
                                        [label]="driverTruckPhotoUrl=='assets/file/image/dlysz.png' ? '点击上传':'重新上传'"
                                        class="p-button-sm" icon="pi pi-cloud-upload"
                                        [style]="{'width':'100px'}"></button>
                                    <input #driverTruckInput type="hidden" (click)="driverTruckFileUpload.clear()" />
                                </span>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="p-field p-grid">
                <div class="p-field p-col-6 p-md-12 edit-sel"
                    style="font-weight: 700;font-size:18px;color: var(--text-color);">基本信息</div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="realname">司机姓名
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <input id="realname" type="text" pInputText formControlName="realname"
                            class="p-inputtext-sm p-text-value">
                    </div>
                    <small *ngIf="checkFormItem(validateDriverTruckForm, 'realname')" class="p-error block error-msg">
                        请填写司机姓名
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="mobilePhone">手机号
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-inputMask id="mobilePhone" formControlName="mobilePhone" [style]="{width: '100%'}"
                            class="p-inputtext-sm p-text-value cus_input" mask="999 9999 9999"></p-inputMask>
                    </div>
                    <small *ngIf="checkFormItem(this.validateDriverTruckForm, 'mobilePhone')"
                        class="p-error block error-msg">
                        请填写正确格式手机号
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="politicalOutlook">政治面貌
                        <span class="label-sel">*</span>
                    </label>
                    <p-dp-detail [options]="politicalOutlookLists" formControlName="politicalOutlook"
                        id="politicalOutlook" appendTo="body" class="p-inputtext-sm p-text-value">
                    </p-dp-detail>
                    <small *ngIf="checkFormItem(this.validateDriverTruckForm, 'politicalOutlook')"
                        class="p-error block error-msg">
                        请选择政治面貌
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="sex">性别</label>
                    <div class="filed-input">
                        <p-radioButton required name="sex" value="1" formControlName="sex"></p-radioButton>
                        &nbsp;
                        <label class="deposit">男</label>
                        &nbsp;
                        <p-radioButton required name="sex" value="0" formControlName="sex"></p-radioButton>
                        &nbsp;
                        <label class="fdeposit">女</label>
                        <small *ngIf="checkFormItem(this.validateDriverTruckForm, 'sex')"
                            class="p-error block error-msg">
                            请填写性别
                        </small>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="birthDate">出生年月</label>
                    <div class="filed-input">
                        <p-calendar formControlName="birthDate" id="birthDate" class="p-inputtext-sm p-text-value"
                            dateFormat="yy-mm-dd" dataType="string" appendTo="body">
                        </p-calendar>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="idCardNo">身份证号
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-inputMask id="idCardNo" formControlName="idCardNo" [style]="{width: '100%'}"
                            mask="999 999 9999 9999 999*" characterPattern="[*X]" class="p-inputtext-sm p-text-value">
                        </p-inputMask>
                    </div>
                    <small *ngIf="checkFormItem(this.validateDriverTruckForm, 'idCardNo')"
                        class="p-error block error-msg">
                        请填写身份证号
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-6 edit-sel">
                    <label for="address">住址
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <input id="address" type="text" pInputText formControlName="address"
                            class="p-inputtext-sm p-text-value">
                    </div>
                    <small *ngIf="checkFormItem(this.validateDriverTruckForm, 'address')"
                        class="p-error block error-msg">
                        请填写住址
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="startUseDate">身份证有效期起
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-calendar formControlName="startUseDate" id="startUseDate" class="p-inputtext-sm p-text-value"
                            dateFormat="yy-mm-dd" dataType="string" appendTo="body"></p-calendar>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="endUseDate">身份证有效期止
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-calendar formControlName="endUseDate" id="endUseDate" class="p-inputtext-sm p-text-value"
                            dateFormat="yy-mm-dd" dataType="string" appendTo="body">
                        </p-calendar>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="qualificationCertNo">从业资格证号
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <input id="qualificationCertNo" type="text" pInputText formControlName="qualificationCertNo"
                            class="p-inputtext-sm p-text-value">
                        <small *ngIf="checkFormItem(this.validateDriverTruckForm, 'qualificationCertNo')"
                            class="p-error block error-msg">
                            请填写从业资格证
                        </small>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="qualificationCertExpireTime">从业资格证失效日期
                        <!-- <span class="label-sel">*</span> -->
                    </label>
                    <div class="filed-input">
                        <p-calendar inputId="qualificationCertExpireTime" formControlName="qualificationCertExpireTime"
                            dateFormat="yy-mm-dd" class="p-inputtext-sm p-text-value" appendTo="body" dataType="string"
                            [inputStyle]="{fontWeight: 'bold'}"></p-calendar>
                        <!-- <small *ngIf="checkFormItem(this.validateForm, 'qualificationCertExpireTime')"
                            class="p-error block error-msg">
                            请选择从业资格证失效日期
                        </small> -->
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="insureProvince">从业资格证颁发机构所在地
                        <!-- <span class="label-sel">*</span> -->
                    </label>
                    <div class="filed-input">
                        <p-dp-detail [options]="insProvinceList" formControlName="insureProvince" filter="false"
                            id="insureProvince" appendTo="body" class="p-inputtext-sm"
                            (onChange)="changeinsProvinceList($event, index)">
                        </p-dp-detail>
                        <!-- <small *ngIf="checkFormItem(this.validateForm, 'qualificationCertNo')"
                            class="p-error block error-msg">
                            请选择从业资格证颁发机构所在地
                        </small> -->
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="qualificationCertIssueAreaCode">从业资格证颁发机构所在地
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-dp-detail [options]="insCityList" formControlName="qualificationCertIssueAreaCode"
                            filter="false" id="qualificationCertIssueAreaCode" appendTo="body" class="p-inputtext-sm">
                        </p-dp-detail>
                        <small *ngIf="checkFormItem(this.validateDriverTruckForm, 'qualificationCertIssueAreaCode')"
                            class="p-error block error-msg">
                            请选择从业资格证颁发机构所在地
                        </small>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-12 edit-sel"
                    style="font-weight: 700;font-size:18px;color: var(--text-color);">驾驶证信息</div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="driverType">准驾车型
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-dp-detail [options]="driverTypeList" formControlName="driverType" filter="true"
                            id="driverType" appendTo="body" class="p-inputtext-sm p-text-value">
                        </p-dp-detail>
                    </div>
                    <small *ngIf="checkFormItem(this.validateDriverTruckForm, 'driverType')"
                        class="p-error block error-msg">
                        请选择准驾车型
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="drivingStartUseDate">驾驶证有效期起
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-calendar inputId="drivingStartUseDate" formControlName="drivingStartUseDate"
                            dateFormat="yy-mm-dd" class="p-inputtext-sm p-text-value" appendTo="body" dataType="string"
                            [inputStyle]="{fontWeight: 'bold'}"></p-calendar>
                    </div>
                    <small *ngIf="checkFormItem(this.validateDriverTruckForm, 'drivingStartUseDate')"
                        class="p-error block error-msg">
                        请选择驾驶证有效期起
                    </small>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="drivingEndUseDate">驾驶证有效期止
                        <span class="label-sel">*</span>
                    </label>
                    <div class="filed-input">
                        <p-calendar inputId="drivingEndUseDate" formControlName="drivingEndUseDate"
                            dateFormat="yy-mm-dd" class="p-inputtext-sm p-text-value" appendTo="body" dataType="string"
                            [inputStyle]="{fontWeight: 'bold'}"></p-calendar>
                        <small *ngIf="checkFormItem(this.validateDriverTruckForm, 'endUseDate')"
                            class="p-error block error-msg">
                            请选择驾驶证有效期止
                        </small>
                    </div>
                </div>
                <div class="p-field p-col-6 p-md-3 edit-sel">
                    <label for="issuingOrganizations">驾驶证发证机关</label>
                    <div class="filed-input">
                        <input id="issuingOrganizations" type="text" pInputText formControlName="issuingOrganizations"
                            class="p-inputtext-sm p-text-value">
                    </div>
                </div>




                <div class="p-field p-col-6 p-md-6 edit-sel">
                    <label for="remark">备注</label>
                    <div class="filed-input">
                        <input id="remark" type="text" pInputText formControlName="remark"
                            class="p-inputtext-sm p-text-value">
                    </div>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" *ngIf="editDialogType == 1" (click)="saveDriver()" label="保存"
            class="p-button-text">
        </p-button>
        <p-button icon="pi pi-check" *ngIf="editDialogType == 2" (click)="check()" label="审核通过" class="p-button-text">
        </p-button>
        <p-button icon="pi pi-check" *ngIf="editDialogType == 2" (click)="check_waybill_noPass(res)" label="审核不通过"
            class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="editDialogFlag = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>
<!-- 编辑司机结束 -->

<!-- 导入数据 -->
<p-dialog [(visible)]="importDialog" [modal]="false" [style]="{width: dialog_width_small}" [draggable]="true"
    [resizable]="false" [keepInViewport]="false" *ngIf="importDialog" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            导入
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || importDialog = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="exportForm" style="width:100%;padding:24px 16px 0 16px;">
        <div class="p-field p-grid">
            <div class="p-md-12 filed-item" style="font-size: 18px;">
                请先下载
                <a href="javascript:;" pRipple (click)="chooseTemplateExcel()" style="color: #f01313;">模板</a>
                ，然后进行导入
            </div>
            <div class="p-md-12 filed-item">
                <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                    <span class="upload-photo upload-photo-span" style="width: '100px'; height: '30px';z-index: 5;">
                        <p-fileUpload #importExcelUpload mode="basic" chooseLabel=""
                            (onSelect)="onSelectImportExcel($event)" [fileLimit]="1" accept=".xls" multiple="multiple"
                            [style]="{'zIndex': '10',opacity:'0',width: '100px', height: '30px'}"
                            maxFileSize="32*1048*1048"></p-fileUpload>
                    </span>
                    <span class="upload-photo upload-photo-span" style="width: '100px'; height: '30px';z-index: 2;">
                        <button pButton pRipple type="button" label="选择" class="p-button-sm" icon="pi pi-cloud-upload"
                            [style]="{'width':'100px'}"></button>
                    </span>
                </div>
            </div>
            <div class="p-md-12 filed-item" style="display: flex;">
                <p-chip *ngIf="uploadExcelFile != null" [label]="uploadExcelFile['name']" styleClass="p-mr-2"
                    [removable]="true" (onRemove)="uploadExcelFile = null"></p-chip>
            </div>
            <div class="p-md-12 filed-item">
                <label for="isMemberTruck" class="p-mr-2 p-d-inline">车辆来源</label>
                <p-dropdown id="isMemberTruck" [options]="truckSourceList" formControlName="isMemberTruck"
                    placeholder="请选择车辆来源" appendTo="body" [style]="{'width':'200px'}"></p-dropdown>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <input type="hidden" #importfileUpload (click)="importExcelUpload.clear()" />
        <p-button icon="pi pi-check" (click)="importCheckExcel()" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="importDialog = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>




<!-- ==========================关联司机信息开始========================== -->
<p-dialog [(visible)]="relDriverDialogFlag" [modal]="false" [style]="{width: dialog_width_large}" [draggable]="true"
    [keepInViewport]="false" [resizable]="false" *ngIf="relDriverDialogFlag" (onShow)="dialogBlock = true">
    <!-- <ng-template pTemplate="header">
        <span style="font-weight: 600;font-size: large;margin-right:20px;">
            托运方列表
            <span style="font-weight: 700;font-size: small;">( {{ dialogRelTitle }} )</span>
        </span>
    </ng-template> -->
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            托运方列表
            <span style="font-weight: 700;font-size: small;">( {{ dialogRelTitle }} )</span>
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || relDriverDialogFlag = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <div class="button-panel">
        <button pButton pRipple type="button" label="新增" icon="pi pi-plus" class="p-button-sm p-mr-2"
            (click)="editAgentorRelDriver()"></button>
        <button pButton pRipple type="button" label="删除" [disabled]="selectAgentorRelList.length === 0"
            icon="pi pi-trash" class="p-button-sm p-button-danger" (click)="delRelDriver()"></button>
        <button pButton pRipple type="button" label="刷新" icon="pi pi-search" class="p-button-sm p-ml-2"
            (click)="queryRelDriver()"></button>
    </div>
    <p-table [value]="relAgentorDriverDataList" [loading]="relDriverloading" styleClass="p-datatable-sm"
        [scrollable]="true" scrollHeight="flex" [(selection)]="selectAgentorRelList"
        styleClass="p-datatable-sm  p-datatable-gridlines" [resizableColumns]="true" columnResizeMode="expand">
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <col style="width:12px">
                <col style="text-align: center;width:120px;" />

            </colgroup>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width:12px" class="th">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">托运方名称</th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">关联时间</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-res>
            <tr>
                <td style="width:12px" class="td">
                    <p-tableCheckbox [value]="res"></p-tableCheckbox>
                </td>
                <td style="text-align: center;width:120px;" class="td">
                    {{keysFunction['cusId'].format(res['shipperId'], res)}}

                </td>
                <td style="text-align: center;width:120px;" class="td">
                    {{keysFunction['createTime'].format(res['createTime'], res)}}

                </td>


            </tr>
        </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <div style="height:20px;"></div>
    </ng-template>
</p-dialog>


<!--新增托运方关联开始-->
<p-dialog [(visible)]="editIdCardDialogFlag" [modal]="false" class='edit-data' [style]="{width: '500px' }"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="editIdCardDialogFlag"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            关联托运方
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || editIdCardDialogFlag = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateRelDriverForm">
        <div class="p-field p-grid p-col-6 p-md-12">
            <label for="cusId" class="p-col-fixed" style="width:90px">托运方</label>
            <div class="p-col edit-sel">
                <p-dp-detail [options]="ShipperList" formControlName="cusId" filter="true" id="cusId" appendTo="body"
                    class="p-inputtext-sm" emptyMessage="未查询到数据" emptyFilterMessage="未查询到数据" [style]="{width: '100%'}"
                    optionLabel="label" optionValue="value" [showClear]="true" [autoDisplayFirst]="false">
                </p-dp-detail>
                <small *ngIf="checkFormItem(this.validateRelDriverForm, 'cusId')" class="p-error block error-msg">
                    请选择关联托运方
                </small>
            </div>
        </div>

    </form>
    <ng-template pTemplate="footer">
        <button pButton pRipple icon="pi pi-check" type="button" (click)="saveAgentorRelDriver()" label="关联"
            class="p-button-raised"></button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="editIdCardDialogFlag = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- ==========================关联区域合伙人信息开始========================== -->
<p-dialog [(visible)]="relTruckDialogFlag" [modal]="false" [style]="{width: dialog_width_large}" [draggable]="true"
    [keepInViewport]="false" [resizable]="false" *ngIf="relTruckDialogFlag" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            区域合伙人列表
            <span style="font-weight: 700;font-size: small;">( {{ dialogRelTitle }} )</span>
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || relTruckDialogFlag = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <!-- <ng-template pTemplate="header">
        <span style="font-weight: 600;font-size: large;margin-right:20px;">
            区域合伙人列表
            <span style="font-weight: 700;font-size: small;">( {{ dialogRelTitle }} )</span>
        </span>
    </ng-template> -->
    <div class="button-panel">
        <button pButton pRipple type="button" label="新增" icon="pi pi-plus" class="p-button-sm p-mr-2"
            (click)="editAgentRelTruck()"></button>
        <button pButton pRipple type="button" label="删除" [disabled]="selectTruckRelList.length === 0" icon="pi pi-trash"
            class="p-button-sm p-button-danger" (click)="delRelTruck()"></button>
        <button pButton pRipple type="button" label="刷新" icon="pi pi-search" class="p-button-sm p-ml-2"
            (click)="queryRelTruck()"></button>
    </div>
    <p-table [value]="relAgentTruckDataList" [loading]="relDriverloading" styleClass="p-datatable-sm"
        [scrollable]="true" scrollHeight="flex" [(selection)]="selectTruckRelList"
        styleClass="p-datatable-sm  p-datatable-gridlines" [resizableColumns]="true" columnResizeMode="expand">
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <col style="width:12px">
                <col style="text-align: center;width:120px;" />

            </colgroup>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width:12px" class="th">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">区域合伙人名称</th>
                <th pResizableColumn style="text-align: center;width:120px;" class="th">关联时间</th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-res>
            <tr>
                <td style="width:12px" class="td">
                    <p-tableCheckbox [value]="res"></p-tableCheckbox>
                </td>
                <td style="text-align: center;width:120px;" class="td">
                    {{keysFunction['agentId'].format(res['agentId'], res)}}

                </td>
                <td style="text-align: center;width:120px;" class="td">
                    {{keysFunction['createTime'].format(res['createTime'], res)}}

                </td>


            </tr>
        </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <div style="height:20px;"></div>
    </ng-template>
</p-dialog>


<!--新增区域合伙人关联开始-->
<p-dialog [(visible)]="editTruckDialogFlag" [modal]="false" class='edit-data' [style]="{width: '500px' }"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="editTruckDialogFlag"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            关联区域合伙人
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || editTruckDialogFlag = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateRelTruckForm">
        <div class="p-field p-grid p-col-6 p-md-12">
            <label for="agentId" class="p-col-fixed" style="width:90px">区域合伙人</label>
            <div class="p-col edit-sel">
                <p-dp-detail [options]="agentIdList" formControlName="agentId" filter="true" id="agentId"
                    appendTo="body" class="p-inputtext-sm" emptyMessage="未查询到数据" emptyFilterMessage="未查询到数据"
                    [style]="{width: '100%'}" optionLabel="label" optionValue="value" [showClear]="true"
                    [autoDisplayFirst]="false">
                </p-dp-detail>
                <small *ngIf="checkFormItem(this.validateRelTruckForm, 'agentId')" class="p-error block error-msg">
                    请选择关联区域合伙人
                </small>
            </div>
        </div>

    </form>
    <ng-template pTemplate="footer">
        <button pButton pRipple icon="pi pi-check" type="button" (click)="saveAgentRelTruck()" label="关联"
            class="p-button-raised"></button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="editTruckDialogFlag = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 批量查询开始 -->
<p-dialog class="edit-order" [(visible)]="batchPlateNumberDialog" position="center" [dismissableMask]="false"
    [modal]="false" [style]="{width: '330px'}" [draggable]="true" [keepInViewport]="false" [resizable]="false"
    *ngIf="batchPlateNumberDialog" (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            批量查询
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || batchPlateNumberDialog = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="batchNoForm" style="background-color: #ffffff;border-radius: 12px;padding:24px 16px;">

        <div>
            <label id="batchNo" class="label_common">批量查询</label>
            <textarea pInputTextarea formControlName="batchNo" style="width:98%;" rows="15"
                placeholder="打开EXCEL,批量复制车牌号到此处"></textarea>
        </div>

    </form>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="batchNo()" label="确定" class="p-button-text"></p-button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="batchPlateNumberDialog = flase|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>


<!--批量关联车主-->
<p-dialog [(visible)]="teamTruckDialogFlag" [modal]="false" class='edit-data' [style]="{width: '500px' }"
    [draggable]="true" [resizable]="false" [keepInViewport]="false" *ngIf="teamTruckDialogFlag"
    (onShow)="dialogBlock = true">
    <ng-template pTemplate="header">
        <div class="p-dialog-title">
            关联车主
        </div>
        <button type="button" [ngClass]="{ 'p-dialog-header-icon p-dialog-header-close p-link': true }"
            (click)="dialogBlock = false || teamTruckDialogFlag = false" pRipple>
            <span class="p-dialog-header-close-icon" class="pi pi-times"></span>
        </button>
    </ng-template>
    <form [formGroup]="validateRelTeamTruckForm">
        <div class="p-field p-grid p-col-6 p-md-12">
            <label for="teamId" class="p-col-fixed" style="width:90px">车主</label>
            <div class="p-col edit-sel">
                <p-dp-detail [options]="teamIdList" formControlName="teamId" filter="true" id="teamId" appendTo="body"
                    class="p-inputtext-sm" emptyMessage="未查询到数据" emptyFilterMessage="未查询到数据" [style]="{width: '100%'}"
                    optionLabel="label" optionValue="value" [showClear]="true" [autoDisplayFirst]="false">
                </p-dp-detail>
                <small *ngIf="checkFormItem(this.validateRelTeamTruckForm, 'teamId')" class="p-error block error-msg">
                    请选择关联车主
                </small>
            </div>
        </div>
        <div class="p-fluid filed-body">
            <div class="p-field p-grid">
                <div class="p-md-12 filed-item">
                    <label for="departWeight" style="width:90px">协议照片</label>
                    <div class="upload-photo-box" [style]="{width: '100px', height: '30px'}">
                        <span class="upload-photo upload-photo-span" style="width: '100px'; height: '30px';z-index: 5;">
                            <p-fileUpload #departPhoto mode="basic" chooseLabel=""
                                (onSelect)="onSelectDepartPhoto($event)" [fileLimit]="5" accept="image/*"
                                multiple="multiple" [disabled]="departUploadFileList.length >= 5"
                                [style]="{'zIndex': '10',opacity:'0',width: '100px', height: '30px'}"
                                maxFileSize="32*1048*1048"></p-fileUpload>
                        </span>
                        <span class="upload-photo upload-photo-span" style="width: '100px'; height: '30px';z-index: 2;">
                            <button pButton pRipple type="button" [disabled]="departUploadFileList.length >= 5"
                                label="选择" class="p-button-sm" icon="pi pi-cloud-upload"
                                [style]="{'width':'100px'}"></button>
                        </span>
                    </div>
                </div>
                <div class="p-md-12 filed-item" style="display: flex;">
                    <ng-container *ngFor="let item of uploadImg;let i = index">
                        <div class="upload-photo-box" *ngIf="item && item['img_url']"
                            (click)="priviewImgss(uploadImg,i)"
                            [style]="{backgroundImage: 'url(' + item['img_url'] + ')', width: '200px',height:'200px'}">
                            <a class="upload-photo-a" href="javascript:;" pRipple (click)="deleteDepartFile(i)">
                                <i class="pi pi-trash"></i>
                            </a>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <input type="hidden" #clearDepartFileUpload (click)="departPhoto.clear()" />
        <button pButton pRipple icon="pi pi-check" type="button" (click)="saveTeamRelTruck()" label="关联"
            class="p-button-raised"></button>
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="this.teamTruckDialogFlag = false|| dialogBlock = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>

<!-- 绑定or解绑车主默认收款 -->